import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { STATIC_STRINGS } from "../../../../../utils/Constants";

const RenderError = ({
  onRetry,
  error,
}: {
  onRetry?: () => void;
  error?: any;
}) => {
  return (
    <div className="card text-center h-2/3 mx-auto flex items-center justify-center">
      <div>
        <ErrorOutlineIcon color="error" fontSize="large" />
        <h2 className="text-lg font-semibold text-red-600 mt-2">
          {STATIC_STRINGS.ERROR_MESSAGE}
        </h2>
        <p className="text-gray-600 mt-1">
          {STATIC_STRINGS.ASSESSMENT_API_ERROR}
        </p>
        <button onClick={onRetry} className="btn btn-outline mt-2">
          {STATIC_STRINGS.RETRY}
        </button>
      </div>
    </div>
  );
};

export default RenderError;
